export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
  'login.form.title': 'Sign in',
  'login.form.hint.user': 'Login',
  'login.form.hint.password': 'Password',
  'login.form.checkbox.remember-me': 'Remember me',
  'login.form.button.sign-in': 'Sign in',
  'login.form.message.invalid-user-credentials': 'Login or password is incorrect',
  'login.form.message.user-required': 'Enter an login',
  'login.form.message.password-required': 'Enter an Password',
  'login.form.button.forgot-password': 'Forgot password?',
  'error.root-admin-login.title': 'Error 403 – forbidden',
  'error.root-admin-login.message': 'You are logged in as a Read-Only Administrator. To access Web Recovery console please log in as a customer tenant user or administrator instead'
};
